/**
 * This middleware is responsible for opening/closing
 * the dialog. It returns a Promise that is
 * resolved/rejected when the user responds to the
 * dialog.
 */

import { CANCEL_DIALOG, CONFIRM_DIALOG, OPEN_DIALOG } from 'stash/store/slices/dialog.slice';
import type { Middleware } from 'redux';

let confirm: (() => void) | undefined;
let cancel: (() => void) | undefined;

const dialog: Middleware = () => (next) => (action: unknown) => {
	const typedAction = action as { type: string };
	if (typedAction.type === OPEN_DIALOG) {
		// Fire the OPEN_DIALOG action through to the reducer.
		next(action);

		return new Promise<void>((resolve, reject) => {
			confirm = resolve;
			cancel = reject;
		});
	}

	if (typedAction.type === CONFIRM_DIALOG) {
		typeof confirm === 'function' && confirm();
	}

	if (typedAction.type === CANCEL_DIALOG) {
		typeof cancel === 'function' && cancel();
	}

	return next(action);
};

export default dialog;
